import axios, { AxiosError } from 'axios';
import { useState, useEffect } from 'react';
import { getJobById, getJobByJobCode, IJob } from 'wisestep-api';

const useJob = (jobId: string): [IJob | undefined, boolean] => {
  const [jobDetails, setJobDetails] = useState<IJob>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const getJobId = async () => {
      try {
        setIsLoading(true);
        if (jobId) {
          const jobDetailsResponse =
            jobId.length > 9 ? await getJobById(jobId) : await getJobByJobCode(jobId);
          setJobDetails(jobDetailsResponse.data);
        }
        setIsLoading(false);
      } catch (e) {
        const error = e as Error | AxiosError;
        if (!axios.isAxiosError(error)) {
          console.log(error);
        }
        console.log(error);
      }
    };
    getJobId();
  }, [jobId]);
  return [jobDetails, isLoading];
};
export default useJob;
